module.exports = __webpack_public_path__ + "static/media/zalo.d90e3879.png";